import { ButtonMui } from 'src/components/ButtonMui'
import styled from 'styled-components'

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 0.4rem 0 0.4rem 0;
  max-width: 100%;
`

export const BoxFooter = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
  margin-top: 1rem !important;
`

export const CustomButton = styled(ButtonMui)`
  width: 18rem;
  height: 2.5rem !important;
`
